// components/NotFoundRedirect.tsx
'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function NotFoundRedirect() {
  const router = useRouter();
  useEffect(() => {
    router.replace('/');
  }, [router]);
  return <p className="text-sm text-muted-foreground mt-2">홈으로 이동합니다.</p>;
}